import { useEffect, useMemo, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { DataTable, DataTablePagination } from 'components/common'
import { useQuery } from 'hooks'
import { fetchLastMileLogs } from 'utils/api/logsApi'
import { calculateOffset } from 'utils/helpers/pagination'
import { filterEmptyValues, FilterMeta } from 'utils/helpers'
import { FILTER_FIELD_LAST_MILE_LOG } from './lastMileLogFilterForm'
import { getColumns } from './utils'

type Props = {
  onFilterMeta?: (filterMeta: FilterMeta) => void
}

const LastMileLogTable = ({ onFilterMeta }: Props) => {
  const [logResponse, setLogResponse] = useState<any>({})
  const [page, setPage] = useState<number>(0)

  const { getAllQueries } = useQuery()
  const { search } = useLocation()

  const columns = useMemo(() => getColumns({ page }), [page])

  const getLogs = async () => {
    try {
      const queries = getAllQueries()
      const { limit, page: pageParam } = queries
      const filters = filterEmptyValues(
        queries[FILTER_FIELD_LAST_MILE_LOG] || {},
      )

      const { data } = await fetchLastMileLogs({
        limit: limit || 10,
        page: pageParam || 1,
        ...filters,
      })

      setPage(calculateOffset(data))
      setLogResponse(data)
      if (data?.filterMeta) {
        onFilterMeta?.(data.filterMeta)
      }
    } catch (error) {
      setLogResponse({ docs: [] })
    }
  }

  useEffect(() => {
    getLogs()
  }, [search])

  return (
    <>
      <DataTable columns={columns} rows={logResponse?.docs} identifier="_id" />

      <DataTablePagination
        currentPage={logResponse?.page}
        totalPages={logResponse?.totalPages}
        hasNextPage={logResponse?.hasNextPage}
        hasPrevPage={logResponse?.hasPrevPage}
        limit={logResponse?.limit}
        nextPage={logResponse?.nextPage}
        prevPage={logResponse?.prevPage}
      />
    </>
  )
}

export default LastMileLogTable
